<template>
    <span :class="statusSpecificConfig.className" :title="statusSpecificConfig.title">
        <i :class="statusSpecificConfig.icon"></i> {{ credit.outward_facing_status | humanise }}
    </span>
</template>

<script>
import OutwardFacingStatuses from "./consts/outward_facing_statuses";
import humanise from "../Utility/filters/humanise";

export default {
    name: 'OutwardFacingStatus',

    props: {
        credit: {
            required: true,
            type: Object,
        },
    },

    filters: {humanise},

    data() {
        return {
            [OutwardFacingStatuses.EXPIRED]: {
                className: 'text-danger',
                icon: 'fa fa-ban',
                title: '',
            },
            [OutwardFacingStatuses.PENDING]: {
                className: 'text-warning',
                icon: 'fa fa-clock',
                title: '',
            },
            [OutwardFacingStatuses.REMOVED]: {
                className: 'text-danger',
                icon: 'fa fa-ban',
                title: this.credit.removal_motive,
            },
            [OutwardFacingStatuses.USED_UP]: {
                className: 'text-danger',
                icon: 'fa fa-ban',
                title: '',
            },
            [OutwardFacingStatuses.VALID]: {
                className: 'text-success',
                icon: 'fas fa-check-circle',
                title: '',
            },
        }
    },

    computed: {
        statusSpecificConfig() {
            return this[this.credit.outward_facing_status];
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Credits/OutwardFacingStatusLabel.vue